import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import SearchIcon from '@mui/icons-material/Search';
import { Select, MenuItem, FormControl, InputLabel } from '@mui/material';
import logoHeader from "../../images/logo_mabe_header.svg"
import { useEffect, useState } from 'react';
import { Container, Drawer, TextField, Button, Stack, Typography } from '@mui/material';
import LogoutIcon from "@mui/icons-material/Logout"
import { useNavigate, Link as RouterLink, Link} from 'react-router-dom';
import { logout } from '../../services/AuthService';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import ModalCatalogs from '../ModalCatalogs/ModalCatalogs';
import { useLocation } from 'react-router-dom';
import { useSearch } from '../../context/KeywordSearchContext';
import { useMaintenanceView } from '../../context/MaintenanceViewContext'; // Import the new context
import { getAllCustomer } from '../../services/CatalogsService';
import { useDataViews } from '../../context/DataViewsContext';


export const Navbar = () => {
    const [isDrawerOpen, setIsDrawnerOpen] = useState(false)
    let navigate = useNavigate()
    let token = localStorage.getItem("site")
    const [openModal, setOpenModal] = useState(false)
    const [tabValue, setTabValue] = useState(0)
    const handleOpenModal = () => { setTabValue(0); setOpenModal(true) }
    const handleCloseModal = () => { setTabValue(0); setOpenModal(false) }
    const handleChangeTap = (event, newValue) => { setTabValue(newValue) }
    const [keywordAux, setKeyword] = useState("")
    const location = useLocation();
    const {  pathname } = location;
    const { updateKeyword, updateCustomer, keyword }=useSearch();
    const { selectedDataSource, setSelectedDataSource, exportData } = useMaintenanceView(); // Use the new context

    const [selectedClient, setSelectedClient] = useState(null);     
    const [clients, setClients] = useState([]); 

    // Obtener las vistas dinámicas del contexto global
    const { dataViews } = useDataViews();

    const logoutAction = async () => {
        try {
            const response = await logout(token)
            if (response.status === 200) {
                localStorage.removeItem("site")
                navigate("/login")
            }
        } catch (err) {
        }
    }
    
    const toggleDrawer = () => {
        setIsDrawnerOpen(!isDrawerOpen)
    }

    const handleClick = () => {
        updateKeyword(""); 
        setKeyword("");
        updateCustomer(null);
        setSelectedClient(null);
    };

    const StyledLink = ({to, children}) => (
        <Box
            component={RouterLink}
            to={to}
            onClick={handleClick} 
            sx={{
                textDecoration: "none",
                color:"inherit",
                '&:hover': {
                    color: 'primary.main',
                }
            }}
        >
            <Typography variant='button'>{children}</Typography>
        </Box>
    )

    const handleKeywordChange = () => {
        updateKeyword(keywordAux)
        //updateCustomer(selectedClient);
    }

    const handleClientChange = (event) => {
        const value = event.target.value;
        setSelectedClient(value);
        updateCustomer(value);
    };

    const fetchClients = async () => {
        try {
            const response = await getAllCustomer(token);            
            if (response.status === 200 && Array.isArray(response.data.content)) {
                setClients(response.data.content);
            }
        } catch (error) {
            console.error("Error cargando clientes:", error);
        }
    };

    useEffect(() => {
        fetchClients();
    }, [keyword]);

    return (
        <Box sx={{flexGrow: 1}}>
            <AppBar position='static' color='secondary'>
                <Toolbar sx={{display: "flex", justifyContent:"space-between"}}>
                    {/* Left section */}
                    <Box sx={{display:"flex", alignItems:"center"}}>
                        <IconButton
                            size="large"
                            edge="start"
                            color='inherit'
                            aria-label='menu'
                            sx={{mr: 2}}
                            onClick={toggleDrawer}
                            >
                            <MenuIcon />
                        </IconButton>
                        <Container sx={{flexFlow: 1}} component="div">
                            <Link to="/dashboard/products">
                                <img src={logoHeader} width={"130px"} alt="Mabe"/>
                            </Link>
                        </Container>
                    </Box>
                    
                    {/* end left section */}

                    {/* center section */}
                    <Box sx={{ flexGrow: 1, display: 'flex', justifyContent: "center", alignItems: "center", mx: 1 }}>
                    
                        {/* Search input - always visible for maintenance view */}
                        {(pathname !== "/dashboard/report" && pathname !== "/dashboard/maintenance"? 
                        <Box>
                            <TextField 
                                placeholder='Search'
                                variant='standard' 
                                margin='normal'
                                value={keywordAux || ''}
                                onChange={(e) => setKeyword(e.target.value)}
                                InputLabelProps={{shrink: false}}
                            />
                            <IconButton color='inherit' aria-label='search' onClick={handleKeywordChange} sx={{cursor:"pointer"}}>
                                <SearchIcon />
                            </IconButton>
                        </Box>
                        : ""
                        )}

                        {/* Data Source Dropdown - only for Maintenance View */}
                        {pathname === "/dashboard/maintenance" && (
                            <Box sx={{ ml: 2 }}>
                                <FormControl variant="standard" sx={{ minWidth: 150 }}>
                                    <InputLabel>Data Source</InputLabel>
                                    <Select
                                        value={selectedDataSource}
                                        onChange={(e) => setSelectedDataSource(e.target.value)}
                                    >
                                        {dataViews.map((view) => (
                                            <MenuItem key={view.name} value={view.name}>{view.name}</MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Box>
                        )}

                        {/* Dropdown Clientes - hidden for Maintenance View */}
                        {(pathname !== "/dashboard/maintenance" && (pathname == "/dashboard/products/CatGeneric" || pathname == "/dashboard/products/GenericProd") ?
                        <Box>
                            <FormControl variant="standard" sx={{ minWidth: 120, ml: 2 }}>
                                <InputLabel>Cliente</InputLabel>
                                    <Select value={selectedClient} onChange={handleClientChange}>
                                        <MenuItem value={null}>Todos</MenuItem> 
                                        {clients.map((client) => (
                                            <MenuItem key={client.id} value={client.id}>{client.name}</MenuItem>
                                        ))}
                                    </Select>
                            </FormControl>
                        </Box>
                            : ""
                        )}
                    </Box>
                    {/* end center section */}

                    {/* right section */}
                    <Box sx={{ display: 'flex'}}>
                        {/* Add Button - hidden for Maintenance View */}
                        {(pathname !== "/dashboard/report" && pathname !== "/dashboard/maintenance" ? 
                          
                        <Button
                            startIcon={<AddCircleIcon />}
                            variant='contained' 
                            color='primary'
                            sx={{marginRight: "4px"}}
                            onClick={handleOpenModal}
                        >
                            Add
                        </Button>
                        : ""
                        )}

                        <ModalCatalogs 
                            openModal={openModal}
                            handleCloseModal={handleCloseModal}
                            tabValue={tabValue}
                            handleChangeTap={handleChangeTap}
                            pathname={pathname}
                        />
                        <Button 
                            startIcon={<LogoutIcon/>} 
                            variant='contained' 
                            color='error'
                            onClick={logoutAction}
                        >Logout</Button>
                    </Box>
                    {/* end right section */}
                </Toolbar>
            </AppBar>
            <Drawer anchor='left' open={isDrawerOpen} onClose={toggleDrawer}>
                <Box
                    sx={{width: 250, padding: "10px"}}
                    role="presentation"
                    onClick={toggleDrawer}
                >
                    <Stack spacing={2} justifyContent="center">
                        <StyledLink to="/dashboard/products">
                            Catalogs Products
                        </StyledLink>
                        <StyledLink to="/dashboard/provinces">
                            Catalogs Providences
                        </StyledLink>
                        <StyledLink to="/dashboard/report">
                            Report
                        </StyledLink>
                        <StyledLink to="/dashboard/products/CatGeneric">
                            Catalog Generic Products
                        </StyledLink>
                        <StyledLink to="/dashboard/products/CotscoProd">
                            Cotsco Prod Inventory
                        </StyledLink>
                        <StyledLink to="/dashboard/products/GenericProd">
                            Generic Prod Inventory
                        </StyledLink>
                        <StyledLink to="/dashboard/maintenance"> {/* New Maintenance View link */}
                            Maintenance View
                        </StyledLink>
                    </Stack>
                </Box>
            </Drawer>
        </Box>
    )
}
